import * as yup from 'yup';

export const UsuarioDetalheSchema = yup.object().shape({
  usu_nome: yup.string().required('Campo é obrigatório'),
  usu_login: yup.string().required('Campo é obrigatório'),
  // [22/10] O e-mail passou a ser obrigatório: é por ele que a senha de primeiro acesso
  // chega. Sem ele, criar o usuário seria criar uma conta que ninguém consegue usar.
  usu_email: yup
    .string()
    .email('Informe um e-mail válido')
    .required('Campo é obrigatório'),
});
